/* STYLING一覧: 記事内の先頭動画を、PCはホバー、タッチ端末は画面内で再生する。 */
(() => {
  'use strict';

  if (customElements.get('mhl-styling-card-video')) return;

  class StylingCardVideo extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template[data-styling-card-video]');
      this.original = this.template?.content.querySelector('video');
      if (!this.original) return;

      this.link = this.closest('a');
      this.hoverMode = matchMedia('(hover: hover) and (pointer: fine)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.failed = false;
      this.pending = false;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const sync = () => this.sync();

      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.link?.addEventListener('focus', () => { this.focused = true; this.sync(); }, options);
      this.link?.addEventListener('blur', () => { this.focused = false; this.sync(); }, options);
      this.hoverMode.addEventListener('change', sync, options);
      this.reducedMotion.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      window.addEventListener('pageshow', sync, options);
      window.addEventListener('pagehide', () => this.stop(), options);
      // 画面に入る少し前から読み込み、表示後のダウンロード待ちを減らす。
      this.preloadObserver = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting || this.reducedMotion.matches) return;
        if (!this.video) this.createVideo();
        this.preloadObserver.disconnect();
      }, { rootMargin: '250px 0px' });
      this.preloadObserver.observe(this);

      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.preloadObserver?.disconnect();
      this.listeners?.abort();
    }

    wantsPlayback() {
      return this.isConnected && this.visible && !document.hidden && !this.failed &&
        !this.reducedMotion.matches &&
        (!this.hoverMode.matches || this.hovered || this.focused);
    }

    createVideo() {
      const video = document.createElement('video');
      video.className = 'mhl-styling-card__video';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = this.hoverMode.matches ? 'metadata' : 'auto';
      video.tabIndex = -1;
      video.setAttribute('aria-hidden', 'true');
      const src = this.original.getAttribute('src');
      if (src) video.src = src;
      this.original.querySelectorAll('source[src]').forEach(source => {
        const copy = document.createElement('source');
        copy.src = source.getAttribute('src');
        if (source.type) copy.type = source.type;
        video.append(copy);
      });
      video.addEventListener('playing', () => {
        if (this.wantsPlayback()) this.classList.add('mhl-styling-card__media--playing');
        else this.stop();
      });
      video.addEventListener('error', () => { this.failed = true; this.stop(); });
      this.append(video);
      this.video = video;
    }

    stop() {
      this.video?.pause();
      this.classList.remove('mhl-styling-card__media--playing');
    }

    sync() {
      if (!this.wantsPlayback()) {
        this.stop();
        return;
      }
      if (!this.video) this.createVideo();
      if (this.pending || !this.video.paused) return;
      this.pending = true;
      let interrupted = false;
      this.video.play().catch(error => {
        // 省電力等で自動再生が拒否された場合は写真と記事リンクを維持する。
        interrupted = error.name === 'AbortError';
        if (!interrupted) this.failed = true;
        this.classList.remove('mhl-styling-card__media--playing');
      }).finally(() => {
        this.pending = false;
        if (!this.wantsPlayback()) this.stop();
        else if (interrupted) this.sync();
      });
    }
  }

  customElements.define('mhl-styling-card-video', StylingCardVideo);
})();
